import React, { useLayoutEffect, useRef, useState } from "react";
import LazyLoad from 'react-lazyload';
import Fancybox from "../assets/js/fancybox";


const PhotoGalleryItem = ({ data }) => {
    const targetRef = useRef();
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const windowSize = useRef([window.innerWidth, window.innerHeight]);
    const monitorWidth = windowSize.current[0];

    useLayoutEffect(() => {
        if (targetRef.current) {
            setDimensions({
                width: targetRef.current.offsetWidth,
                height: targetRef.current.offsetHeight
            });
        }
    }, []);

    let elHeight = Number(dimensions.height);

    const { img, category, itemName, tag } = data;

    return (
        <div ref={targetRef} className={`grid-item ${tag}`}>
            <div className="product_thumb">
                <div className="product_imagebox">
                    <LazyLoad height={monitorWidth <= 600 ? 280 : monitorWidth <= 1536 ? 280 : monitorWidth >= 1918 ? 350 : 280} once>
                        <img
                            className="primary_img"
                            src={img}
                            alt="img"
                        />
                    </LazyLoad>

                </div>

                <div className="product_item_inner">
                    <div className="label_text">
                        <h4 className="food_category">{category}</h4>
                        <h3 className="food_item_name">{itemName}</h3>
                    </div>

                    <div className="details">
                        <Fancybox options={{ dragToClose: false }}>
                            <a data-fancybox="images" href={img}>
                                <i className="ion-ios-plus-empty"></i>
                            </a>
                        </Fancybox>


                    </div>
                </div>

                {/* <br />
                <p>width: {dimensions.width}</p>
                <p>height: {dimensions.height}</p>
                <h2>Width: {windowSize.current[0]}</h2>
                <h2>Height: {windowSize.current[1]}</h2> */}

            </div>
        </div>
    );
};

export default PhotoGalleryItem;